<div class="special-chart-coins" fxLayout="column">
    <div class="special-chart-coins_indicators" fxLayout="column">
        <span class="available text-12-semi-bold"
            >{{ available.name }}
            <div
                fxLyout="row"
                [style.display]="'block'"
                [style.overflow]="'hidden'"
                [style.width]="liquidity * 24 + 'px'"
            >
                <div
                    class="coin available special-chart-coins_symbol"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                    [matTooltip]="available.v"
                >
                    <span>$</span>
                </div>
            </div></span
        >
        <span class="obligatations text-12-semi-bold"
            >{{ obligations.name }}

            <span class="coin obligatations" [matTooltip]="obligations.v"
                >$</span
            >
        </span>
    </div>
    <div fxLayout="column" style="height: calc(100% - 42px)">
        <app-chart-historic
            [options]="options"
            [visualization]="visualization"
            [series]="newSeries"
            [points]="newPoints"
            [company]="company"
        ></app-chart-historic>
    </div>
</div>
